module.exports = __webpack_public_path__ + "img/b_1.a6bc0013.jpg";